module.exports = __webpack_public_path__ + "img/5-2.219b0983.jpg";